import { EditIncidentInfoModal } from "./EditIncidentInfoModal";

export default EditIncidentInfoModal;
